import Vue from 'vue'
import URLAPI from '@/config/urlApi.js'
/**
 * 获取个性化配置
 * @method  getIndividuation
 * @author sansengg
 * @version 2017-04-24
 * @param   {Vue}         vm   vue实例
 * @param   {[type]}         code 配置码'6HAMC7'
 * @return  {[type]}              [description]
 */
function getIndividuation (configCode, macCode = ''){
  if(configCode == '000000'){
    localStorage.removeItem('individuationSetting');
  }
  const setting = localStorage.getItem('individuationSetting');

  if(configCode){
    if(macCode){
      Vue.ajax.jsonp(URLAPI.config.PageConfig.bindconfig, {QueryPageConfigurationCode: configCode, UsedObject: macCode});
    }
    return Vue.ajax.jsonp(URLAPI.config.PageConfig.GetQueryPageConfiguration, {QueryPageConfigurationCode: configCode}).then((result)=>{
      if(result.Result == 200){
        return result.Data;
      }
    });
  }else if(setting){
    return new Promise((resolve, reject)=>{
      resolve(JSON.parse(setting));
    });
  }else{
    if(macCode){
      Vue.ajax.jsonp(URLAPI.config.PageConfig.bindconfig, {QueryPageConfigurationCode: '000000', UsedObject: macCode});
    }
    return new Promise((resolve, reject)=>{
      resolve();
    });
  }
}

function setIndividuation (vm, data = {}){
  const config = data ? data.QueryPageConfiguration : null;
  if(config){
    // Vue.toIndividuation('', {backgroundURL: config.QueryPageBackground});
    localStorage.setItem('individuationSetting', JSON.stringify(data));
    vm.$store.commit('setIndividuation', {
      pageBg: config.QueryPageBackground,
      pageName: config.QueryPageName,
      pageTitle: config.QueryPageTitle,
      pageLogo: config.QueryPageLogo,
      pageLogoType: config.LogoType,
      signature1: config.QueryPageSign1,
      signature2: config.QueryPageSign2,
      signature3: config.QueryPageSign3
    });
  }
}
export {getIndividuation, setIndividuation}



// WEBPACK FOOTER //
// ./src/utils/toIndividuation.js